import { render, staticRenderFns } from "./xiangmu.vue?vue&type=template&id=2ff14baa&scoped=true&"
import script from "./xiangmu.vue?vue&type=script&lang=js&"
export * from "./xiangmu.vue?vue&type=script&lang=js&"
import style0 from "./xiangmu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xiangmu.vue?vue&type=style&index=1&id=2ff14baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff14baa",
  null
  
)

export default component.exports